<template>
    <div class="wl-textual-research">
        <div class="textual-research-content">
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">我要考证的流程</span></h3>
            <div class="my-flow-chart">
                <img src="../../assets/images/my-flow-chart.png" alt="">
            </div>
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">物流师职业等级考试申报条件</span></h3>
            <div class="logistics-grade-list clearfix">
                <div class="logistics-grade-con lf">
                    <div class="grade-hade">
                        <i class="wl-icon-zhiye"></i>
                        物流员（国家职业资格四级）
                    </div>
                    <div class="grade-skill-content">
                        <p>   物流员的考试申报条件（具备以下条件之一）</p>
                        <p>（1）中专（含职高）物流类专业毕业生（含在校应届毕业生）；</p>
                        <p>（2）高中及以上学历毕业且从事物流相关工作满一年者；</p>
                        <p>（3）中专（含职高）及以下学历非物流类专业毕业生经培训并取得合格证书者。</p>
                    </div>
                </div>
                <div class="logistics-grade-con rh">
                    <div class="grade-hade">
                        <i class="wl-icon-zhiye"></i>
                        助理物流师（国家职业资格三级）
                    </div>
                    <div class="grade-skill-content">
                        <p>助理物流师的考试申报条件（具备以下条件之一）</p>
                        <p>（1）经助理级正规培训达规定标准学时数，并取得合格证书者；</p>
                        <p>（2）连续从事本职业或相关职业5年以上者； </p>
                        <p>（3）具有相关专业大专学历者。</p>
                    </div>
                </div>
                <div class="logistics-grade-con lf">
                    <div class="grade-hade">
                        <i class="wl-icon-zhiye"></i>
                        中级物流师（国家职业资格二级） 
                    </div>
                    <div class="grade-skill-content">
                        <p>  中级物流师的考试申报条件（具备以下条件之一）</p>
                        <p>（1）取得本认证助理级证书后，连续从事本职业工作3年以上，经中级正规培训达规定标准学时数，并取得合格证书者；</p>
                        <p>（2）取得助理级证书后，连续从事本职业工作5年以上者；</p>
                        <p>（3）取得大专院校物流专业学历的毕业生，连续从事本职业工作满3年者；</p>
                        <p>（4）取得相关专业学士学位者。</p>
                    </div>
                </div>
                <div class="logistics-grade-con rh">
                    <div class="grade-hade">
                        <i class="wl-icon-zhiye"></i>
                        高级物流师（国家职业资格一级）
                    </div>
                    <div class="grade-skill-content">
                        <p>高级物流师的考试申报条件（具备以下条件之一）</p>
                        <p>（1）取得中级证书后，连续从事本职业工作3年以上，经本职业高级正规培训达标准时数，并取得合格证书者；</p>
                        <p>（2）取得中级证书后，连续从事本职业工作5年以上者；</p>
                        <p>（3）取得相关专业学士学位，连续从事本职业或相关职业3年以上者；</p>
                        <p>（4）取得相关专业硕士学位者。</p>
                    </div>
                </div>
            </div>
            <h3 class="h3-wl-title"><span class="sp-border-class"></span> <span class="sp-title-text">教材及学习资料</span></h3>
            <div class="teaching-material-list clearfix">
                <div class="teaching-resource-li lf clearfix">
                    <div class="resource-img lf">
                        <img src="../../assets/images/new-course-cover.jpg" alt="">
                    </div>
                    <div class="resource-book-info lf">
                        <p class="resource-book-name">货物运输实务</p>
                        <p>作者：郭希哲</p>
                        <p>适用对象：物流员及助理级别认证</p>
                        <p class="p-chapter-text">章节目录：</p>
                        <p class="p-chapter-content">单元1：货物运输概述；单元2：公路货物运输；单元3：铁路货物运输；单元4：航空货物运输；单元5：水路货物运输；单元6：多式联运；单元7：货物运输单证和风险管理</p>
                    </div>
                </div>
                <div class="teaching-resource-li lf clearfix">
                    <div class="resource-img lf">
                        <img src="../../assets/images/new-course-cover.jpg" alt="">
                    </div>
                    <div class="resource-book-info lf">
                        <p class="resource-book-name">货物运输实务</p>
                        <p>作者：郭希哲</p>
                        <p>适用对象：物流员及助理级别认证</p>
                        <p class="p-chapter-text">章节目录：</p>
                        <p class="p-chapter-content">单元1：货物运输概述；单元2：公路货物运输；单元3：铁路货物运输；单元4：航空货物运输；单元5：水路货物运输；单元6：多式联运；单元7：货物运输单证和风险管理</p>
                    </div>
                </div>
                <div class="teaching-resource-li lf clearfix">
                    <div class="resource-img lf">
                        <img src="../../assets/images/new-course-cover.jpg" alt="">
                    </div>
                    <div class="resource-book-info lf">
                        <p class="resource-book-name">货物运输实务</p>
                        <p>作者：郭希哲</p>
                        <p>适用对象：物流员及助理级别认证</p>
                        <p class="p-chapter-text">章节目录：</p>
                        <p class="p-chapter-content">单元1：货物运输概述；单元2：公路货物运输；单元3：铁路货物运输；单元4：航空货物运输；单元5：水路货物运输；单元6：多式联运；单元7：货物运输单证和风险管理</p>
                    </div>
                </div>
                <div class="teaching-resource-li lf clearfix">
                    <div class="resource-img lf">
                        <img src="../../assets/images/new-course-cover.jpg" alt="">
                    </div>
                    <div class="resource-book-info lf">
                        <p class="resource-book-name">货物运输实务</p>
                        <p>作者：郭希哲</p>
                        <p>适用对象：物流员及助理级别认证</p>
                        <p class="p-chapter-text">章节目录：</p>
                        <p class="p-chapter-content">单元1：货物运输概述；单元2：公路货物运输；单元3：铁路货物运输；单元4：航空货物运输；单元5：水路货物运输；单元6：多式联运；单元7：货物运输单证和风险管理</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>
